// extracted by mini-css-extract-plugin
export default {"skeleton":"SectionUserChannelsCatchup_skeleton__jFFlK","box":"SectionUserChannelsCatchup_box__+s8H7"};